// Module
var code = `<div appHeaderBar> <header-bar-title>Contact</header-bar-title>  </div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container HOA-container--border-tb u-mB6">
        <div class="HOA-container HOA-container--border-bOnly">
            <div class="HOA-container__header">
                <!--TODO add {{property.hoa.contactInformation.displayName}}-->
                <h1 class="HOA-container__header-text-normal HOA-container__child--flex-full" tid="hoaDisplayName">
                    <!-- TODO: Add the blue line and header formatting -->
                    <div *ngIf="pmc.name"
                         tid="contactMgmtTitle"
                         class="HOA-contactinformation-flextable__header-text HOA-contactinformation-flextable__header-text--colorBlack">
                        {{pmc.name}}
                    </div>
                    <div *ngIf="!pmc.name"
                         tid="contactMgmtTitle"
                         class="HOA-contactinformation-flextable__header-text HOA-contactinformation-flextable__header-text--colorBlack">
                        First Citizens Bank
                    </div>
                </h1>
                <!--            Removing this image as it is hidden on the screen at all times-->
                <!--            <div *ngIf="true" class="HOA-property-container__header-logo">-->
                <!--                <img class="hide" src="@app/pages/properties/landing/propertylanding-pmc-logo.png" alt="Property Management Company Logo" />-->
                <!--            </div>-->
            </div>
        </div>

        <div class="HOA-container__content HOA-container__content--borderNone HOA-font-light">
            <div *ngIf="showPmcInfo">
                <div tid="contactForPropertyQuestions"
                     class="HOA-flextable-component__subheader u-mT2 u-mB6 page-contact__subheader-text" >
                    For questions regarding your property or payments due, please contact:
                </div>

                <div class="page-contact__contactInfoContainer u-mB6">
                    <div tid="contactMgmtInfoName"  class="HOA-contactinformation-flextable__address-text" id="contactMgmtInfoName">
                        {{pmc.name}}
                    </div>
                    <div tid="contactMgmtInfoStreet" class="HOA-contactinformation-flextable__address-text" id="contactMgmtInfoStreet">
                        {{pmc.contactInformation.mailingAddress[0].line1}}
                    </div>
                    <div tid="contactMgmtInfoUnit" class="HOA-contactinformation-flextable__address-text" id="contactMgmtInfoUnit">
                        {{pmc.contactInformation.mailingAddress[0].unit}}
                    </div>
                    <div tid="contactMgmtInfoCityStateZip" class="HOA-contactinformation-flextable__address-text" id="contactMgmtInfoCityStateZip">
                        {{pmc.contactInformation.mailingAddress[0].city}}
                        {{pmc.contactInformation.mailingAddress[0].state}}
                        {{pmc.contactInformation.mailingAddress[0].postalCode}}
                    </div>
                    <div tid="contactMgmtInfoPhone" id="contactMgmtInfoPhone">
                        <a style="text-decoration:none"  href="tel:{{displayPhoneNumber}}"
                           [attr.aria-label]="'Phone number ' + displayPhoneNumber">{{displayPhoneNumber | phone}}

                        </a>
                    </div>
                    <div *ngIf="pmc.contactInformation.email && pmc.contactInformation.email.length > 0"
                         tid="contactMgmtInfoEmail" id="contactMgmtInfoEmail">
                        <a style="text-decoration:none" href="mailto:{{pmc.contactInformation.email[0].value}}">
                            {{pmc.contactInformation.email[0].value}}
                        </a>
                    </div>
                    <div *ngIf="displayUrl" tid="contactMgmtInfoWeb" id="contactMgmtInfoWeb">
                        <a style="text-decoration:none" href="" (click)="openUrl('http://'+displayUrl)">{{displayUrl}}</a>
                    </div>
                </div>

                <div class="HOA-container__content-hrule u-mB6"></div>
            </div>

            <div class="HOA-flextable-component__subheader u-mT6 u-mB6">
                    <span tid="contactForSiteQuestions"
                          class="hide-if-platform-size-phone page-contact__subheader-text">
                        For questions regarding this site, please contact:
                    </span>
                <span tid="contactForAppQuestions"
                      class="hide-if-platform-web page-contact__subheader-text">
                        For questions regarding this app, please contact:
                    </span>
            </div>

            <div class="page-contact__contactInfoContainer">
                <div tid="contactBankInfoName">First-Citizens Bank & Trust Company</div>
                <div tid="contactBankInfoAttn">Attn: Property Pay</div>
                <div tid="contactBankInfoStreet">PO Box 27131</div>
                <div tid="contactBankInfoCityStateZip">Raleigh, NC 27611</div>
                <div>Customer Service:
                    <a style="text-decoration:none"  tid="contactBankInfoPhone" href="tel:866-800-4656" aria-label="Phone number 866-800-4656" >(866) 800-4656 option 3</a>
                </div>
                <div>
                    <a style="text-decoration:none"  tid="contactBankInfoEmail" href="mailto:servicepropertypay@firstcitizens.com">servicepropertypay@firstcitizens.com</a>
                </div>
                <div>
                    <a style="text-decoration:none" tid="contactBankInfoWeb"
                       href="" (click)="openUrl('https://www.firstcitizens.com/hosted/community-association-banking-customer-support')">
                        firstcitizens.com/cab
                    </a>
                </div>
            </div>
            <div>
                <div class="HOA-font-fine-print u-mT4">
                    *Email is for general inquiry only. Please do not include personal information or account numbers
                    in your email. If you have an account specific question, please call customer service.
                </div>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;